import React from 'react'

/**
 * Visually-hidden CSS properties — equivalent to @mui/utils visuallyHidden,
 * kept local to avoid pulling that subpackage in as a project dependency.
 */
const VISUALLY_HIDDEN: React.CSSProperties = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
}

export default VISUALLY_HIDDEN
